// "use strict";

// import Vue from 'vue';
// import axios from "axios";

// // Full config:  https://github.com/axios/axios#request-config
// // axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// // axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// let config = {
//   // baseURL: process.env.baseURL || process.env.apiUrl || ""
//   // timeout: 60 * 1000, // Timeout
//   // withCredentials: true, // Check cross-site Access-Control
// };

// const _axios = axios.create(config);

// _axios.interceptors.request.use(
//   function(config) {
//     // Do something before request is sent
//     return config;
//   },
//   function(error) {
//     // Do something with request error
//     return Promise.reject(error);
//   }
// );

// // Add a response interceptor
// _axios.interceptors.response.use(
//   function(response) {
//     // Do something with response data
//     return response;
//   },
//   function(error) {
//     // Do something with response error
//     return Promise.reject(error);
//   }
// );

// Plugin.install = function(Vue) {
//   Vue.axios = _axios;
//   window.axios = _axios;
//   Object.defineProperties(Vue.prototype, {
//     axios: {
//       get() {
//         return _axios;
//       }
//     },
//     $axios: {
//       get() {
//         return _axios;
//       }
//     },
//   });
// };

// Vue.use(Plugin)

// export default Plugin;

/**
 * axios 基础配置
 */
 import axios from 'axios'
  import { getCookie } from '@/plugins/cookie'

 // axios.defaults.baseURL = process.env.NODE_ENV == 'development' ? '//backend-api-01.newbee.ltd/api/v1' : '//backend-api-01.newbee.ltd/api/v1'
 axios.defaults.timeout = 20000
 // this.axios.defaults.withCredentials=true
//  if(process.env.NODE_ENV!='production'){
//   axios.defaults.crossDomain = true
//  }
 axios.defaults.crossDomain = true
 
 //加上X-Requested-Wit后分享报跨域错误
 //axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
//  axios.defaults.headers['appvars'] = `{"token": "${token}"}`
//  axios.defaults.headers['Content-Type'] = 'application/json'
 axios.defaults.headers.post['Content-Type'] = 'application/json'
 //请求拦截
 axios.interceptors.request.use(config =>{
  if(config.url.indexOf('loginByWechat')==-1){
    if(process.env.NODE_ENV=='production'){
      const loginToken = getCookie('loginToken')
      config.headers['appvars'] = `{"loginToken": "${loginToken}"}`
    }else{
      const loginToken = getCookie('loginToken') || '56e3690bbcae79ef365f57a52c614062'
      config.headers['appvars'] = `{"loginToken": "${loginToken}"}`
    }
  }
  return config;
 },err=>{
   return Promise.reject(err);
 })
 axios.interceptors.response.use(res => {
   
     if (typeof res.data !== 'object') {
      //  Toast.fail('服务端异常!')
       return Promise.reject(res)
     }
     // console.log(res.data)
     // if (res.data.resultCode != 200) {
     //   if (res.data.message) Toast.fail(res.data.message)
     //   if (res.data.resultCode == 501) {
     //     Toast.fail('登录状态异常！')
     //   }
     //   return Promise.reject(res.data)
     // }
     // return res.data
     return res.data
   })
 
   export default axios